<template>
  <div>
  <div class="pages" v-if="!showRule">
    <div class="top-tab">
      <h3>返校预约</h3>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="预约审核" name="0">
          <div class="filter">
            <div>
              <el-form size="small" :inline="true">
                <el-form-item label="是否开车">
                  <el-select v-model="formInline.IsCar" clearable>
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="学校" v-if="$store.state.userinfo.isSuper">
              <el-select
                clearable
                v-model="formInline.School"
                placeholder="请选择学校"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
                <el-form-item label="毕业年份">
                  <el-date-picker
                    v-model="formInline.EndYear"
                    value-format="yyyy"
                    type="year"
                    placeholder="选择年"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </div>
            <div class="search">
              <el-form size="small" :inline="true">
                <el-form-item label="">
                  <el-input
                    clearable
                    v-model="formInline.Key"
                    placeholder="请输入关键词查询"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchList">搜索</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="预约记录" name="1">
          <div class="filter">
            <div>
              <el-form size="small" :inline="true">
                <el-form-item label="是否开车">
                  <el-select v-model="formInline.IsCar" clearable>
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="学校" v-if="$store.state.userinfo.isSuper">
              <el-select
                clearable
                v-model="formInline.School"
                placeholder="请选择学校"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
                <el-form-item label="毕业年份">
                  <el-date-picker
                    v-model="formInline.EndYear"
                    value-format="yyyy"
                    type="year"
                    placeholder="选择年"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="formInline.PrebookState" clearable>
                    <el-option label="待核验" :value="0"></el-option>
                    <el-option label="已取消" :value="1"></el-option>
                    <el-option label="未通过" :value="2"></el-option>
                    <el-option label="已核验" :value="3"></el-option>
                    <el-option label="未返校" :value="4"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否随行">
                  <el-select v-model="formInline.IsTogether" clearable>
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="search">
              <el-form size="small" :inline="true">
                <el-form-item label="">
                  <el-input
                    clearable
                    v-model="formInline.Key"
                    placeholder="请输入关键词查询"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchHistoryList"
                    >搜索</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="table">
      <div v-show="activeName == 0">
        <el-button type="primary" size="medium" @click="setHandle"  v-if="!$store.state.userinfo.isSuper"
          >设置</el-button
        >
        <!-- <el-button type="primary" size="medium" @click="setHandle" 
          >设置</el-button
        > -->
        <el-button type="primary" size="medium" @click="judStudents"
          >批量审核</el-button
        >
        <el-button type="primary" size="medium" @click="ruleManageHandle"  v-if="$store.state.userinfo.isSuper"
          >返校规则管理</el-button
        >
        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
          height="4.92rem"
          max-height="4.92rem" 
          style="width: 100%"
        >
          <el-table-column
            show-overflow-tooltip
            type="selection"
            align="center"
            width="50"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            type="index"
            label="序号"
            align="center"
            width="50"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="userName"
            label="预约人姓名"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="school"
            label="所属学校"
            align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="college"
            label="学院"
            align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="major"
            label="专业"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="毕业年份"
            property="endYear"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="retuenSchoolTime"
            label="预约时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="carNumber"
            label="车牌号"
            align="center"
          >
          <template  slot-scope="scope">
{{scope.row.carNumber?scope.row.carNumber:'-'}}
          </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="togetherPersonCount"
            label="随行人数"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="retuenSchoolReason"
            label="返校事由"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="createTime"
            label="提交时间"
            align="center"
            width="260"
          >
          </el-table-column>
          <el-table-column
            property="auditState"
            label="审核状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.auditState === 0" size="small"
                >待审核</el-tag
              >
              <el-tag
                v-if="scope.row.auditState === 1"
                size="small"
                type="success"
                >通过</el-tag
              >
              <el-tag
                v-if="scope.row.auditState === 2"
                size="small"
                type="danger"
                >未通过</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="see(scope.row, 0)" type="text" size="medium"
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-show="activeName == 1">
        <el-table :data="tableData" height="5.28rem" max-height="5.28rem">
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="userName"
            label="预约人姓名"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="school"
            label="所属学校"
            align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="college"
            label="学院"
            align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="major"
            label="专业"
            align="center"
          >
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="毕业年份"
            property="endYear"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="retuenSchoolTime"
            label="预约时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="carNumber"
            label="车牌号"
            align="center"
          >
          <template  slot-scope="scope">
{{scope.row.carNumber?scope.row.carNumber:'-'}}
          </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="togetherPersonCount"
            label="随行人数"
            align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="retuenSchoolReason"
            label="返校事由"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="createTime"
            label="提交时间"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="auditTime"
            label="审核时间"
            align="center"
            width="200"
          >
          <template  slot-scope="scope">
{{scope.row.auditTime?scope.row.auditTime:'-'}}
          </template>
          </el-table-column>
          <!-- <el-table-column
            property="auditState"
            label="审核状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.auditState === 0" size="small"
                >待审核</el-tag
              >
              <el-tag
                v-if="scope.row.auditState === 1"
                size="small"
                type="success"
                >通过</el-tag
              >
              <el-tag
                v-if="scope.row.auditState === 2"
                size="small"
                type="danger"
                >未通过</el-tag
              >
            </template>
          </el-table-column> -->
          <el-table-column
            property="prebookState"
            label="预约状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.prebookState === 0" size="small"
                >待核验</el-tag
              >
              <el-tag
                v-if="scope.row.prebookState === 1"
                size="small"
                type="info"
                >已取消</el-tag
              >
              <el-tag
                v-if="scope.row.prebookState === 2"
                size="small"
                type="danger"
                >未通过</el-tag
              >
              <el-tag
                v-if="scope.row.prebookState === 3"
                size="small"
                type="success"
                >已核验</el-tag
              >
              <el-tag
                v-if="scope.row.prebookState === 4"
                size="small"
                type="danger"
                >未返校</el-tag
              >
            </template>
          </el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            property="verifyCount"
            label="检验次数"
            align="center"
          >
            <template #default="{ row }">
              {{ row.verifyCount === 0 ? "暂无" : row.verifyCount }}
            </template>
          </el-table-column> -->
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button @click="see(scope.row, 1)" type="text" size="medium"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="  prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>

    <setDialog
      :showDialog="setDialogVisible"
      @closeSetDialog="closeSetDialog"
    />

    <el-drawer
      size="45%"
      :title="handleType === 0 ? '审核' : '查看'"
      :visible.sync="centerDialogVisible"
      direction="rtl"
      class="judge-pop"
    >
      <div class="state" v-if="handleType === 1">
        <el-descriptions column="1">
          <el-descriptions-item label="预约状态">
            <el-tag v-if="currStudentInfo.prebookState === 0" size="small"
                >待核验</el-tag
              >
              <el-tag
                v-if="currStudentInfo.prebookState === 1"
                size="small"
                type="info"
                >已取消</el-tag
              >
              <el-tag
                v-if="currStudentInfo.prebookState === 2"
                size="small"
                type="danger"
                >未通过</el-tag
              >
              <el-tag
                v-if="currStudentInfo.prebookState === 3"
                size="small"
                type="success"
                >已核验</el-tag
              >
              <el-tag
                v-if="currStudentInfo.prebookState === 4"
                size="small"
                type="danger"
                >未返校</el-tag
              >
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="info">
        <el-descriptions title="预约信息" column="2">
          <el-descriptions-item label="预约人">{{
            currStudentInfo.userName
          }}</el-descriptions-item>
          <el-descriptions-item label="学院专业">{{
            `${currStudentInfo.college}-${currStudentInfo.major}`
          }}</el-descriptions-item>
          <el-descriptions-item label="学历层次">{{
            currStudentInfo.educationStr
          }}</el-descriptions-item>
          <el-descriptions-item label="毕业年份">{{
            currStudentInfo.endYear
          }}</el-descriptions-item>
          <el-descriptions-item label="返校时间">{{
            currStudentInfo.retuenSchoolTime
          }}</el-descriptions-item>
          <el-descriptions-item label="返校天数"
            >{{ currStudentInfo.retuenSchoolCount }}天</el-descriptions-item
          >
          <el-descriptions-item label="车牌号">{{
            currStudentInfo.carNumber ? currStudentInfo.carNumber : "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{
            currStudentInfo.phone
          }}</el-descriptions-item>
        </el-descriptions>
        <div class="allow-people">
          <h3>随行人信息</h3>
          <div class="count">
            随行人数：{{
              currStudentInfo.returnSchoolPrebookTogetherPerson.length
            }}
          </div>
        </div>
        <div class="people-list">
          <div
            class="people-item"
            v-for="(v, i) in currStudentInfo.returnSchoolPrebookTogetherPerson"
            :key="i"
          >
            <div class="name">随行人{{ i + 1 }}姓名：{{ v.name }}</div>
            <div class="phone">随行人{{ i + 1 }}联系电话：{{ v.phone }}</div>
          </div>
          <div
            v-if="!currStudentInfo.returnSchoolPrebookTogetherPerson.length"
            style="display: flex;justify-content: center;width: 100%;"
          >
            暂无
          </div>
        </div>
        <div class="return-reason">
          <span class="reason-title">返校事由：</span>
          <p class="reason-text">
            {{ currStudentInfo.retuenSchoolReason }}
          </p>
        </div>
      </div>
      <div class="other-info">
        <el-descriptions title="其他信息" column="1">
          <el-descriptions-item label="提交时间">
            {{ currStudentInfo.createTime ? currStudentInfo.createTime : "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="取消时间" v-if="currStudentInfo.prebookState === 1">
            {{ currStudentInfo.cancelTime ? currStudentInfo.cancelTime : "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="审核状态">
            <el-tag v-if="currStudentInfo.auditState === 0 &&currStudentInfo.prebookState === 1" size="small"
                >未审核</el-tag
              >
              <el-tag v-if="currStudentInfo.auditState === 0 &&currStudentInfo.prebookState !== 1" size="small"
                >待审核</el-tag
              >
              <el-tag
                v-if="currStudentInfo.auditState === 1"
                size="small"
                type="success"
                >通过</el-tag
              >
              <el-tag
                v-if="currStudentInfo.auditState === 2"
                size="small"
                type="danger"
                >未通过</el-tag
              >
          </el-descriptions-item>
          <el-descriptions-item label="审核时间">
            {{ currStudentInfo.auditTime ? currStudentInfo.auditTime : "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="核验时间">
            {{
              currStudentInfo.returnSchoolPrebookVerify.length
                ? currStudentInfo.returnSchoolPrebookVerify[currStudentInfo.returnSchoolPrebookVerify.length-1].verifyTime
                : "-"
            }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="judge-info" v-if="false">
        <h3>随行人信息</h3>
        <el-table :data="currStudentInfo.returnSchoolPrebookVerify">
          <el-table-column
            type="index"
            align="center"
            prop="date"
            label="核验次数"
            width="150"
          >
          </el-table-column>
          <el-table-column align="center" prop="verifyTime" label="核验时间">
          </el-table-column>
        </el-table>
      </div>
      <div class="judge-section dialog-footer" v-if="handleType === 0">
        <el-button type="primary" size="small" @click="submit">通过</el-button>
        <el-button size="small" @click="reject">驳回</el-button>
      </div>
    </el-drawer>
  </div>
<ruleManage v-if="showRule" @backHander="backHander"/>
</div>
</template>
<script>
import education from "../../components/userDetail/education.vue"; //教育经历认证
import setDialog from "./components/setDialog.vue";
import ruleManage from "./components/ruleManage.vue";
import {
  GetReturnSchoolPrebooksWaitAuditApi,
  GetReturnSchoolPrebooksRecordApi,
  AuditReturnSchoolPrebookApi,
  GetReturnSchoolPrebookInfoApi
} from "@/request/requestApi.js";
export default {
  data() {
    return {
      showRule:false,
      //学校
      schoolList: [],
      handleType: 0,
      setDialogVisible: false,
      activeName: 0,
      centerDialogVisible: false,
      tableData: [],
      judgeTableData: [],
      formInline: {
        Key: "",
        IsCar: null,
        IsTogether: null,
        EndYear: "",
        School:"",
        PrebookState: null
      },
      //学生信息
      // currStudentInfo: [],
      currStudentInfo: {
        returnSchoolPrebookVerify: [],
        returnSchoolPrebookTogetherPerson: []
      },
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
      //多选框
      multipleSelection: [],
      //批量审核id
      judIds: []
    };
  },
  created() {
    this.getReturnRecordList();
    this.getSchoolList()
  },
  mounted() {},
  methods: {
    //获取学校
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize,
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    reject() {
      this.$prompt("确认驳回申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.+$/,
        inputErrorMessage: "请填写理由"
      })
        .then(({ value }) => {
          this.adjustStudent([this.currStudentInfo.id], 2, value);
        })
        .catch(() => {});
    },
    submit() {
      this.$confirm("确认通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.adjustStudent([this.currStudentInfo.id], 1);
        })
        .catch(() => {});
    },
    setHandle() {
      this.setDialogVisible = true;
    },
    closeSetDialog() {
      this.setDialogVisible = false;
    },
    //批量审核
    judStudents() {
      if (this.judIds.length <= 0) {
        this.$message.error("请至少选择一条审核信息！");
        return false;
      }
      this.$confirm("确认批量通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.adjustStudent(this.judIds, 1);
        })
        .catch(() => {});
    },
    ruleManageHandle() {
      this.showRule=  true
    },
    backHander() {
      this.showRule=  false
    },
    //关闭
    close() {
      this.centerDialogVisible = false;
    },
    handleSelectionChange(val) {
      this.judIds = [];
      this.multipleSelection = val;
      console.log(this.multipleSelection);
      this.multipleSelection.forEach(element => {
        this.judIds.push(element.id);
      });
      console.log(this.judIds);
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.formInline = {
        label: "",
        role: "",
        dataValue: "",
        Key: ""
      };
      if (this.activeName == 0) {
        this.getReturnRecordList();
      } else if (this.activeName == 1) {
        this.getHistoryStudentList();
      }
    },
    see(val, type) {
      this.centerDialogVisible = true;
      this.handleType = type;
      this.getStudentInfo(val.id);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      if (this.activeName == 0) {
        this.getReturnRecordList(this.currentPage, this.currentSize);
      } else if (this.activeName == 1) {
        this.getHistoryStudentList(this.currentPage, this.currentSize);
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      if (this.activeName == 0) {
        this.getReturnRecordList(this.currentPage, this.currentSize);
      } else if (this.activeName == 1) {
        this.getHistoryStudentList(this.currentPage, this.currentSize);
      }
    },
    searchList() {
      this.currentPage = 1;
      this.getReturnRecordList(this.currentPage);
    },
    //获取列表
    async getReturnRecordList(pageIndex = 1, pageSize = 10) {
      const params = {
        PageIndex: pageIndex,
        PageSize: pageSize,
        IsCar: this.formInline.IsCar,
        EndYear: this.formInline.EndYear,
        School: this.formInline.School,
        Key: this.formInline.Key
      };
      let res = await GetReturnSchoolPrebooksWaitAuditApi(params);

      if (res.succeed) {
        this.tableData = res.data.item1;
        this.totalCount = res.data.item2;
        if (this.tableData.length <= 0 && this.currentPage > 1) {
          this.getReturnRecordList(--this.currentPage);
        }
      } else {
        this.$message.error(res.error);
      }
    },
    searchHistoryList() {
      this.currentPage = 1;
      this.getHistoryStudentList(this.currentPage);
    },
    //获取历史列表
    async getHistoryStudentList(pageIndex = 1, pageSize = 10) {
      const params = {
        PageIndex: pageIndex,
        PageSize: pageSize,
        IsCar: this.formInline.IsCar,
        EndYear: this.formInline.EndYear,
        School: this.formInline.School,
        Key: this.formInline.Key,
        PrebookState: this.formInline.PrebookState,
        IsTogether: this.formInline.IsTogether
      };
      let res = await GetReturnSchoolPrebooksRecordApi(params);
      if (res.succeed) {
        this.tableData = res.data.item1;
        this.totalCount = res.data.item2;
        this.tableData.forEach(element => {
          element.createTime = element.createTime.substring(0, 10);
        });
        console.log(this.tableData);
      } else {
        this.$message.error(res.error);
      }
    },
    //获取学深信息
    async getStudentInfo(currId) {
      let res = await GetReturnSchoolPrebookInfoApi({ Id: currId });
      if (res.succeed) {
        // this.currStudentInfo = [];
        // this.currStudentInfo.push(res.data);
        this.currStudentInfo = res.data;
      } else {
        this.$message.error(res.error);
      }
    },
    //审核
    async adjustStudent(currId, state, cancleReason = "") {
      let res = await AuditReturnSchoolPrebookApi({
        id: currId,
        auditState: state,
        auditRemark: cancleReason
      });
      if (res.succeed) {
        this.$message.success("操作成功！");
        this.close();
        this.getReturnRecordList(this.currentPage, this.currentSize);
      } else {
        this.$message.error(res.error);
      }
    },
    //动态获取url
    getUrl(url, queryConfig) {
      //var queryConfig={"page" : "index", "method" : 2}
      var that = this;
      var _str = "";
      for (var obj in queryConfig) {
        if (!that.isNull(queryConfig[obj])) {
          _str += obj + "=" + queryConfig[obj] + "&";
        }
      }
      console.log(_str.length);
      if (_str.length > 0) {
        return url + _str.substring(0, _str.length - 1);
      } else {
        return "";
      }
    },
    //判空方法
    isNull(val = "") {
      if (val == undefined || val == null) {
        return true;
      }
      var str = val.toString().replace(/(^\s*)|(\s*$)/g, ""); //去除空格;
      if (str == "" || str == undefined || str == null) {
        return true;
      }
    }
  },
  components: {
    setDialog,ruleManage
  }
};
</script>
<style lang="scss" scoped>
.top-tab {
  padding: 0.2rem;
  background-color: #fff;
  border-radius: 10px;
  h3 {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 20px;
    color: #363636;
  }
}
.table {
  margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.3rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.filter {
  // padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  display: flex;
  justify-content: space-between;
  >>> .el-form-item {
    margin-bottom: 0;
  }
}
.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;
  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }
  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}
.judge-pop {
  >>> .el-drawer__header span {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
  >>> .el-descriptions-item__container > span {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
  .state {
    padding: 0.3rem 0.6rem;
    border-bottom: 1px solid #eeeeee;
  }
  .info {
    padding: 0.3rem 0.6rem;
    border-bottom: 1px solid #eeeeee;
    .allow-people {
      margin-top: 0.12rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h3 {
        font-weight: bold;
        font-size: 16px;
        color: #333333;
      }
      .count {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
    }
    .people-list {
      margin-top: 0.2rem;
      padding: 0.24rem;
      background: #507bf410;
      border-radius: 10px;
      .people-item {
        margin-top: 0.24rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .phone,
        .name {
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
      }
      .people-item:first-child {
        margin-top: 0 !important;
      }
    }
    .return-reason {
      margin-top: 0.24rem;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      display: flex;
      .reason-text,
      .reason-title {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
      .reason-title {
        white-space: nowrap;
      }
      .reason-text {
        width: 90%;
        word-wrap: break-word;
      }
    }
  }
  .judge-info {
    width: 100%;
    padding: 0.3rem 0.6rem;
    padding-top: 0;
    h3 {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
    }
  }
  .other-info {
    padding: 0.3rem 0.6rem;
    // margin-bottom: 30px;
  }
  .judge-section {
    // position: absolute;
    // bottom: 0;
    width: 100%;
    padding: 0.3rem 0.6rem;
    display: flex;
    justify-content: end;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/backSchool/appointment.vue